import { AxiosError } from 'axios';
import {
  IAppState,
  IAppTheme,
  IExtensionsRegistration,
  IKeyValueItem
} from '@msx/platform-services'

export interface ReduxCommonState {
  isLoading: string[];
  error: Error;
}
export interface IAnnouncementId {
  id: string;
  expiryDate: string;
};
export interface ReduxAppState {
  locale: string;
  currentTheme: IAppTheme;
  currentAppState: IAppState;
  currentGuidedTourRunStatus: boolean;
  inDashboardEditMode: boolean;
  currentTestExtensoins: IKeyValueItem[];
  mockData: boolean;
  localeData: IKeyValueItem[];
  selectedCategories ?: [];
  dismissedAnnouncements ?: any;
  titleLoaderName?:any;
  isLoader:boolean;
  isBotError:boolean;
  addTile:boolean;
  botToken:string;
  currentUserData?:any;
  childComponentName?:string;
  hasServiceRequestTypeLogData?:boolean;
  ServiceRequestTypeLogData?:any;
  LogEventData?:any;
  isCustomeLog?:boolean;
  isUserDataUpdated?:boolean;
  preferenceChanged?:boolean;
  recommendedTiles?: [];
  initialize: boolean;
  subIssueTypes: any;
  isWwicCopilot: boolean;
  isConversationId: boolean;
  currentConversationId: string;
  isAiSearchedTile: boolean;
  ticketDetailsData:[];
  activeTicketCount:any;
}

export interface ReduxExtensionsRegistrationState {
  extensionsRegistration: IExtensionsRegistration;
  isLoading: boolean;
  error: AxiosError;
}

export const SET_CURRENT_LOCALE = 'SET_CURRENT_LOCALE';
export const SET_CURRENT_THEME = 'SET_CURRENT_THEME';
export const SET_CURRENT_APP_STATE = 'SET_CURRENT_APP_STATE';
export const SET_IS_MOCK_DATA = 'SET_IS_MOCK_DATA';
export const SET_LOCALE_DATA = 'SET_LOCALE_DATA';
export const SET_CURRENT_TEST_EXTENSIONS = 'SET_CURRENT_TEST_EXTENSIONS';
export const SET_IN_DASHBOARD_EDIT_MODE = "SET_IN_DASHBOARD_EDIT_MODE";

export const FETCH_EXTENSIONS_REGISTRATION_BEGIN = 'FETCH_EXTENSIONS_REGISTRATION_BEGIN';
export const FETCH_EXTENSIONS_REGISTRATION_SUCCESS = 'FETCH_EXTENSIONS_REGISTRATION_SUCCESS';
export const FETCH_EXTENSIONS_REGISTRATION_FAILURE = 'FETCH_EXTENSIONS_REGISTRATION_FAILURE';
export const SET_CURRENT_DISMISSEDANNOUNCEMENTS = 'SET_CURRENT_DISMISSEDANNOUNCEMENTS';

export const SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY';
export const SET_title_Loader_Name = 'SET_title_Loader_Name';
export const SET_Add_Tile = 'SET_Add_Tile';
export const SET_Is_Loader = 'SET_Is_Loader';
export const SET_Is_Bot_Error = 'SET_Is_Bot_Error';
export const SET_Bot_Token = 'SET_Bot_Token';
export const SET_CURR_USERDATA = 'SET_CURR_USERDATA';
export const SET_CHILD_COMPONENT = 'SET_CHILD_COMPONENT';
export const SET_HAS_SERVICEREQUESTTYPE = 'SET_HAS_SERVICEREQUESTTYPE';
export const SET_SERVICE_REQUESTTYPE_DATA = 'SET_SERVICE_REQUESTTYPE_DATA';
export const SET_LOGEVENT_DATA = 'SET_LOGEVENT_DATA';
export const SET_IS_CUSTOMLOG = 'SET_IS_CUSTOMLOG';
export const SET_USER_DATA_UPDATED = 'SET_USER_DATA_UPDATED';
export const SET_PREFERENCE_CHANGED = 'SET_PREFERENCE_CHANGED';
export const SET_RECOMMENDED_TILES = 'SET_RECOMMENDED_TILES';
export const SET_INITIALIZE_APP = 'SET_INITIALIZE_APP';
export const SET_SUBISSUE_TYPES = 'SET_SUBISSUE_TYPES';
export const SET_IS_WWIC_COPILOT = 'SET_IS_WWIC_COPILOT';
export const SET_IS_CONVERSATION_ID = 'SET_IS_CONVERSATION_ID';
export const SET_CURRENT_CONVERSATION_ID = 'SET_CURRENT_CONVERSATION_ID';
export const SET_IRIS_STATE = 'SET_IRIS_STATE';
export const SET_IS_AI_SEARCHED_Tile = 'SET_IS_AI_SEARCHED_Tile';
export const SET_TICKET_DETAILS_DATA = 'SET_TICKET_DETAILS_DATA';
export const SET_ACTIVETICKET_COUNT='SET_ACTIVETICKET_COUNT';
